import React from 'react';
export function SolutionSection() {
  const grades = ['1°', '2°', '3°', '4°', '5°', '6°'];
  const skills = ['Emociones', 'Autoestima', 'Identidad', 'Diversidad', 'Convivencia', 'Respeto', 'Autocuidado', 'Ciudadanía Digital', 'Resolución de conflictos', 'Buen trato'];
  const designFeatures = ['Consignas claras', 'Recursos visuales', 'Actividades breves y dinámicas', 'Espacios amplios para responder', 'Lenguaje accesible', 'Aplicación inmediata en el aula'];
  return <section className="py-10 px-4 bg-white" data-id="element-143">
      <div className="max-w-4xl mx-auto text-center" data-id="element-144">
        <p className="text-[20px] font-black mb-2 text-[#EF5B4C]" data-id="element-145">
          La solución:
        </p>
        <h2 className="text-2xl md:text-4xl font-black mb-6 text-gray-900 leading-tight" data-id="element-146">
          UN SISTEMA COMPLETO DE ESI PARA TODA LA PRIMARIA
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-147">
          El <span className="font-bold" data-id="element-148">MEGAPACK ESI PRIMARIA</span> está
          organizado para acompañar a docentes de 1° a 6° grado mediante
          actividades listas para imprimir y trabajar durante todo el ciclo
          lectivo.
        </p>

        {/* ¿Cómo está organizado? */}
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 mb-8 border border-gray-100 shadow-sm text-left" data-id="element-149">
          <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-5 text-center" data-id="element-150">
            📚 ¿Cómo está organizado?
          </h3>

          {/* Grados */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-151">
            {grades.map(g => <div key={g} className="bg-white border-2 border-[#16A99A] text-gray-900 font-black w-14 h-14 flex items-center justify-center rounded-xl shadow-sm text-lg" data-id="element-152">
                {g}
              </div>)}
          </div>

          <ul className="space-y-2 max-w-xl mx-auto text-base md:text-lg text-gray-800" data-id="element-153">
            <li className="flex items-start gap-2" data-id="element-154">
              <span className="text-green-500 font-bold" data-id="element-155">✅</span>
              <span data-id="element-156">Primer Ciclo completo</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-157">
              <span className="text-green-500 font-bold" data-id="element-158">✅</span>
              <span data-id="element-159">Segundo Ciclo completo</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-160">
              <span className="text-green-500 font-bold" data-id="element-161">✅</span>
              <span data-id="element-162">Más de 250 actividades listas para imprimir</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-163">
              <span className="text-green-500 font-bold" data-id="element-164">✅</span>
              <span data-id="element-165">Recursos organizados por temas</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-166">
              <span className="text-green-500 font-bold" data-id="element-167">✅</span>
              <span data-id="element-168">Material para todo el año escolar</span>
            </li>
          </ul>
        </div>

        {/* Habilidades */}
        <div className="mb-8 text-left" data-id="element-169">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-170">
            Cada ciclo trabaja temas fundamentales como:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 max-w-2xl mx-auto" data-id="element-171">
            {skills.map(s => <div key={s} className="flex items-center gap-2 text-gray-800 text-base md:text-lg" data-id="element-172">
                <span className="text-[#EF5B4C] font-bold" data-id="element-173">✔</span>
                <span data-id="element-174">{s}</span>
              </div>)}
          </div>
        </div>

        {/* Diseño */}
        <div className="bg-[#FFF4F1] rounded-2xl p-6 md:p-8 mb-8 border border-[#FBD9D2] text-left" data-id="element-175">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-176">
            Todo el material fue diseñado con:
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-177">
            {designFeatures.map(f => <span key={f} className="bg-white border border-[#FBD9D2] text-gray-800 px-3 py-1.5 rounded-full text-sm md:text-base font-medium shadow-sm" data-id="element-178">
                ✨ {f}
              </span>)}
          </div>
        </div>

        <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-179">
          🖨️{' '}
          <span className="px-2 bg-white text-[#8F7DA6]" data-id="element-180">
            Descargás, imprimís y trabajás.
          </span>
        </p>
      </div>
    </section>;
}